// extracted by mini-css-extract-plugin
export default {"message":"SeRGqWU7WPUilwiSiEDQ","link":"nLLxMiuNswgzySxx7_hQ"};